import React, { useEffect, useState } from 'react';

import { useHistory } from 'react-router-dom';
import { isEmpty } from 'lodash';
import { Base64 } from 'js-base64';

import { useSelector } from 'react-redux';
import { ILuxuryHome } from '@share/common-types';
import { Routes } from '@share/constants';

import { faBed, faUser } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBath } from '@fortawesome/free-solid-svg-icons';

import { RootState, RemoveLuxuryHomesParams } from '@share/utils';
import { LuxuryHomesPropertiesFilters } from '../../commons/property-filters/component';

import './style.scss';

const LuxuryHomesFeaturedProperties: React.FC = () => {

  const history = useHistory();

  const { account } = useSelector((state: RootState) => state.loginStore);
  const { homes } = useSelector((state: RootState) => state.luxuryHomesStore);

  const [showMore, setShowMore] = useState(false);
  const [homesfiltered, setHomesfiltered] = useState(homes);
  const [selectedLocation, setSelectedLocation] = useState<string | null>(null);
  const [selectedOcuppancy, setSelectedOcuppancy] = useState<string>('');
  const [selectedBedrooms, setSelectedBedrooms] = useState<string>('');
  const [selectedBathrooms, setSelectedBathrooms] = useState<string>('');
  const [search, setSearch] = useState('');

  const goToDetails = (propertyId: number, unitId: number) => {
    RemoveLuxuryHomesParams();

    const roomId = Base64.encode(unitId?.toString());
    history.push(`/${account?.name}${Routes.LuxuryHomesDetails}/${propertyId}/${roomId}${location.search}`);
  };

  useEffect(() => {
    setHomesfiltered(homes);
  }, [homes]);

  useEffect(() => {
    const hf = homes?.filter((home: ILuxuryHome) => (!selectedLocation || home?.location?.id?.toString() === selectedLocation?.toString()))
                     .filter((home: ILuxuryHome) => (!selectedOcuppancy || home?.units?.map((unit: any) => unit?.maxOccupancy).some((maxOccupancy: number) => (maxOccupancy || 0) >= (selectedOcuppancy ? Number(selectedOcuppancy) : 0))))
                     .filter((home: ILuxuryHome) => (!selectedBedrooms || home?.units?.map((unit: any) => unit?.bedroomsCount).some((bedroomsCount: number) => (bedroomsCount || 0) >= (selectedBedrooms ? Number(selectedBedrooms) : 0))))
                     .filter((home: ILuxuryHome) => (!selectedBathrooms || home?.units?.map((unit: any) => unit?.bathroomsCount).some((bathroomsCount: number) => (bathroomsCount || 0) >= (selectedBathrooms ? Number(selectedBathrooms) : 0))))
                     .filter((home: ILuxuryHome) => (isEmpty(search) || home?.title?.toLowerCase().includes(search.toLowerCase())));
    
    setHomesfiltered(hf);
  }, [selectedLocation, selectedOcuppancy, selectedBedrooms, selectedBathrooms, search]);

  return (
    <section className="featured-properties">
      <div className="featured-properties__container">
        <div className="featured-properties__header">
          <h2>FEATURED PROPERTIES</h2>
          <h3>Our Most Coverred Stays</h3>
          <p>Extraordinary homes, handpicked by travelers like you. These sought-after offer unparalleled luxury, breathtaking views, and unforgettable experiences.</p>
        </div>

        <LuxuryHomesPropertiesFilters 
          selectedLocation={selectedLocation}
          selectedOcuppancy={selectedOcuppancy}
          selectedBedrooms={selectedBedrooms}
          selectedBathrooms={selectedBathrooms}
          search={search}

          setSelectedLocation={setSelectedLocation}
          setSelectedOcuppancy={setSelectedOcuppancy}
          setSelectedBedrooms={setSelectedBedrooms}
          setSelectedBathrooms={setSelectedBathrooms}
          setSearch={setSearch}
        />

        {!homesfiltered?.length && (
          <div className="featured-properties__no-results">
            <h3>No results found for selected criteria</h3>
          </div>)}

        <div className="featured-properties__grid">
          {homesfiltered?.slice(0, !showMore ? 9 : homes?.length).map((property: ILuxuryHome, index: number) => (
            <div key={index} className="destination-card" onClick={() => goToDetails(property.id, property.units[0].id)}>
              <div className="destination-card__image" style={{ backgroundImage: `url(${property.thumb})` }}>
                <div className="destination-card__image-background"></div>
                <div className="destination-card__content">
                  <h3>{property.title?.split(',')[0]}</h3>
                  <p className="destination-card__content-info">
                    {!isEmpty(property.units[0]?.bedRoomType) ? <label style={{ marginRight: '4px' }}>{property.units[0]?.bedRoomType}</label> : ''} {!isEmpty(property.units[0]?.bedRoomType) ? '|' : ''} {property.units[0]?.maxOccupancy || '0'} <FontAwesomeIcon icon={faUser} style={{ marginLeft: '4px', marginRight: '4px' }} /> |  {property.units[0]?.bedroomsCount || '0'} <FontAwesomeIcon icon={faBed} style={{ marginLeft: '4px', marginRight: '4px' }} /> | {property.units[0]?.bathroomsCount || '0'} <FontAwesomeIcon icon={faBath} style={{ marginLeft: '4px' }} />
                  </p>
                  <p>{property.location?.name} | {property.location?.country}</p>
                </div>
              </div>
            </div>))}
        </div>

        {homesfiltered?.length > 9 && (
          <div className="featured-properties__show-more" onClick={() => setShowMore(!showMore)}>
            Show {showMore ? 'Less' : 'More'}...
          </div>)}
      </div>
    </section>
  );
};

export default LuxuryHomesFeaturedProperties; 